<script setup lang=ts>
import {
  OrButtonV3 as OrButton,
} from '@onereach/ui-components';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

import { useAuthStore } from '@/stores/auth/auth';

import config from '../config';
import LoginContainer from '../layouts/LoginContainer.vue';

const router = useRouter();
const authStore = useAuthStore();

const sharedUrl = config.SHARED_URL;

const loading = ref(false);

const loadUsers = async () => {
  await authStore.loadUsers();
};

const availableUsers = computed(() => authStore.availableUsers);

const isMultipleUser = computed(() => availableUsers.value.length > 1);

const listUsers = () => {
  router.push('/multi-user/list-users?fromExpired');
};

const logoutUrl = computed(() => {
  const encodedRedirectPath = encodeURIComponent(`${window.location.origin}/#/`);
  return `${config.AUTH_UI_URL}/logout?redirectPath=${encodedRedirectPath}`;
});


const logout = () => {
  window.parent.location.href = logoutUrl.value;
};

const goToShared = () => {
  window.parent.location.href = sharedUrl;
  return false;
};

onMounted(async () => {
  if (!availableUsers.value.length) {
    loading.value = true;
    await loadUsers();
    loading.value = false;
  }
});
</script>

<template>
  <LoginContainer
    ref="cookieExpireModal"
    class="relogin-modal"
    :background="true"
  >
    <div
      class="reload-form px-md sm:px-0 layout-column items-center w-full sm:w-[340px] md:w-[290px]"
    >
      <div class="typography-headline-2 mb-sm text-center">
        {{ $t('session_expire.Permission denied') }}
      </div>
      <div class="typography-body-2-regular dark:text-outline-dark text-center mb-sm+">
        {{ $t('session_expire.You can switch to Shared app or sign in with another user account') }}
      </div>
      <div
        class="button-wrapper w-full layout-row gap-md justify-between"
      >
        <OrButton
          v-if="isMultipleUser"
          :loading="loading"
          class="reload flex-1"
          variant="outlined"
          @click="listUsers"
        >
          {{ $t('session_expire.Switch account') }}
        </OrButton>
        <OrButton
          v-else
          :loading="loading"
          class="reload flex-1"
          variant="outlined"
          @click="logout"
        >
          {{ $t('session_expire.Sign out') }}
        </OrButton>
        <OrButton
          class="reload flex-1"
          @click="goToShared"
        >
          {{ $t('session_expire.Shared app') }}
        </OrButton>
      </div>
    </div>
  </LoginContainer>
</template>
